export default
{
    props:
    {
        src: { type: String, default: '' },
        poster: { type: String, default: '' },
        isFullscreen: { type: Boolean, default: false },
        isFakeFullscreen: { type: Boolean, default: false },
        currentTime: { type: Number, default: 0 }
    },

    watch:
    {
        isFullscreen: 'onFullscreenChange'
    },

    data()
    {
        return {
            isPlaying: false
        }
    },

    created()
    {
        this._isFullScreen = false
    },

    mounted()
    {
        this.$video = this.$el.querySelector('.js-video')
    },

    methods:
    {
        onTogglePlay()
        {
            this.isPlaying = !this.isPlaying
            this.$el.classList.toggle('is-playing')

            if(this.isPlaying)
            {
                this.$video.play()
                this.$el.classList.add('is-started')
                this.$el.classList.remove('is-paused')
            }
            else
            {
                this.$video.pause()
                this.$el.classList.add('is-paused')
            }
        },

        onPlay()
        {
            this.isPlaying = true
            this.$el.classList.add('is-playing')

            this.$video.play()
            this.$el.classList.add('is-started')
            this.$el.classList.remove('is-paused')
        },

        onPause()
        {
            this.isPlaying = false
            this.$el.classList.remove('is-playing')

            this.$video.pause()
            this.$el.classList.add('is-paused')
        },

        onVideoEnded()
        {
            this.$el.classList.remove('is-started')

            this.onTogglePlay()

            this.$video.currentTime = 0
        },

        onFullscreenChange()
        {
            this._isFullScreen = this.isFullscreen

            if(this.isFullscreen && this.isFakeFullscreen)
            {
                this.$video.currentTime = this.currentTime
                this.onPlay()
            }

            if(!this.isFullscreen && this.isFakeFullscreen)
            {
                this.onPause()
            }

            if(this.isFullscreen && !this.isFakeFullscreen)
            {
                this.onPause()
            }

            if(!this.isFullscreen && !this.isFakeFullscreen)
            {
                this.$video.currentTime = this.currentTime
                this.onPlay()
            }
        },

        onToggleFullscreen()
        {
            this._isFullScreen = !this._isFullScreen

            if(this._isFullScreen)
            {
                this.$emit('set:fullscreen', this.$video.currentTime)

                // this.$el.classList.add('is-fullscreen')

                // if(this.$el.requestFullscreen)
                // {
                //     this.$el.requestFullscreen()
                // }
                // else if(this.$el.mozRequestFullScreen)
                // {
                //     this.$el.mozRequestFullScreen()
                // }
                // else if(this.$el.webkitRequestFullscreen)
                // {
                //     this.$el.webkitRequestFullscreen()
                // }
                // else if(this.$el.msRequestFullscreen)
                // {
                //     this.$el.msRequestFullscreen()
                // }
            }
            else
            {
                this.$emit('remove:fullscreen', this.$video.currentTime)

                // this.$el.classList.remove('is-fullscreen')

                // if(document.exitFullscreen)
                // {
                //     document.exitFullscreen()
                // }
                // else if(document.mozCancelFullScreen)
                // {
                //     document.mozCancelFullScreen()
                // }
                // else if(document.webkitExitFullscreen)
                // {
                //     document.webkitExitFullscreen()
                // }
                // else if(document.msExitFullscreen)
                // {
                //     document.msExitFullscreen()
                // }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/core-video-player/script.js